import React, { Component } from "react";
import "../css/shoppingCart.css";
import DesktopCartItem from './DesktopCartItem';
//import OrderComplete from './OrderComplete';
import { FaArrowCircleRight, FaLock } from 'react-icons/fa';
import StripeCheckout from 'react-stripe-checkout';

import ReactGA from 'react-ga';

class DesktopCart extends Component {

    constructor(props) {
        super(props)
        this.state = {
            cartItems: [],
            subtotal: 0,
            showProcessing: false,
            showOrderComplete: false,
            step: 0,
            shipping_name: "",
            shipping_address_line1: "",
            shipping_address_city: "",
            shipping_address_state: "",
            shipping_address_zip: "",
            shipping_address_phone: ""
        }
    }

    render() {
        console.log(this.state.step)
        return (
            <div style={{ flex: 1 }}>
                {this.renderSteps()}
            </div>
        );
    }

    renderSteps = () => {
        if (this.state.step == 0) {
            return (
                <div>
                    {this.renderProcessing()}
                    <div style={{ paddingTop: "85px", paddingBottom: "95px", maxWidth: "700px", marginLeft: "auto", marginRight: "auto" }}>
                        <div className="desktopCartTop">
                            <div onClick={() => { window.location.href = 'https://www.houseplanstore.com' }} style={{ cursor: "pointer", height: "85px", width: "125px", position: "absolute", top: "-78px", left: "0px" }}>
                                <img src={require('../images/about-logo.png')} style={{ width: 100 + "%", objectFit: "contain" }} />
                            </div>
                            <div onClick={() => { window.location.href = 'https://www.houseplanstore.com' }} style={{ cursor: "pointer", height: "0px", width: "0px", position: "absolute", top: "-35px", left: "119px" }}>
                                <img src={require('../images/allplans-text.png')} style={{ width: 100 + "%", objectFit: "contain" }} />
                            </div>
                            <span className="shoppingCartText">Shopping Cart</span>
                        </div>

                        {this.state.cartItems}
                        {this.renderTotal()}
                        <div className="desktopCheckoutHolder">
                            {this.renderNextStepButton()}
                        </div>
                        {this.renderAskQuestions()}
                    </div>
                </div>
            );
        } else if (this.state.step == 1) {
            return (
                <div>
                    {this.renderProcessing()}
                    <div style={{ paddingTop: "85px", paddingBottom: "95px", maxWidth: "700px", marginLeft: "auto", marginRight: "auto" }}>
                        <div className="desktopCartTop">
                            <div onClick={() => { window.location.href = 'https://www.houseplanstore.com' }} style={{ cursor: "pointer", height: "85px", width: "125px", position: "absolute", top: "-78px", left: "0px" }}>
                                <img src={require('../images/about-logo.png')} style={{ width: 100 + "%", objectFit: "contain" }} />
                            </div>
                            <div onClick={() => { window.location.href = 'https://www.houseplanstore.com' }} style={{ cursor: "pointer", height: "0px", width: "0px", position: "absolute", top: "-35px", left: "119px" }}>
                                <img src={require('../images/allplans-text.png')} style={{ width: 100 + "%", objectFit: "contain" }} />
                            </div>
                            <span className="shoppingCartText">Shipping Address</span>
                        </div>
                        {this.renderShippingInformationForm()}
                        <div className="desktopCheckoutHolder">
                            {this.renderReviewOrderButton()}
                        </div>
                        {this.renderAskQuestions()}
                    </div>
                </div>
            );
        } else if (this.state.step == 2) {
            return (
                <div>
                    {this.renderProcessing()}
                    <div style={{ paddingTop: "85px", paddingBottom: "95px", maxWidth: "700px", marginLeft: "auto", marginRight: "auto" }}>
                        <div className="desktopCartTop">
                            <div onClick={() => { window.location.href = 'https://www.houseplanstore.com' }} style={{ cursor: "pointer", height: "85px", width: "125px", position: "absolute", top: "-78px", left: "0px" }}>
                                <img src={require('../images/about-logo.png')} style={{ width: 100 + "%", objectFit: "contain" }} />
                            </div>
                            <div onClick={() => { window.location.href = 'https://www.houseplanstore.com' }} style={{ cursor: "pointer", height: "0px", width: "0px", position: "absolute", top: "-35px", left: "119px" }}>
                                <img src={require('../images/allplans-text.png')} style={{ width: 100 + "%", objectFit: "contain" }} />
                            </div>
                            <span className="shoppingCartText">Review Order</span>
                        </div>
                        <div className="shippingAddressReviewHolder">
                            <div style={{ marginLeft: 10 }}>
                                <strong>Shipping to:</strong><br /><br />
                                &nbsp;&nbsp;&nbsp;&nbsp;{this.state.shipping_name}<br />
                                &nbsp;&nbsp;&nbsp;&nbsp;{this.state.shipping_address_line1}<br />
                                &nbsp;&nbsp;&nbsp;&nbsp;{this.state.shipping_address_city}, {this.state.shipping_address_state} {this.state.shipping_address_zip}<br />
                                &nbsp;&nbsp;&nbsp;&nbsp;{this.state.shipping_address_phone}
                                <br />
                                <br />
                            </div>
                            <a className="editAddressLink" onClick={() => { this.setState({ step: 1 }) }}>Edit</a>
                        </div>


                        {this.state.cartItems}
                        {this.renderTotal()}
                        <div className="desktopCheckoutHolder">
                            {this.renderCheckoutButton()}
                        </div>
                        {this.renderAskQuestions()}
                    </div>
                </div>
            );
        }
    }

    renderShippingInformationForm = () => {
        return (
            <div style={{
                maxWidth: 700,
                marginRight: 15,
                padding: 20,
                backgroundColor: "#fff",
                marginLeft: 15
            }}>
                <input className="formInput" onChange={e => { this.setState({ shipping_name: e.target.value }) }} value={this.state.shipping_name} placeholder="Name.." type="text" />
                <input className="formInput" onChange={e => { this.setState({ shipping_address_line1: e.target.value }) }} value={this.state.shipping_address_line1} placeholder="Address.." type="text" />
                <div className="mobileFormElementHolder">
                    <input className="mobileFormElement2" onChange={e => { this.setState({ shipping_address_city: e.target.value }) }} style={{ marginLeft: 0 }} value={this.state.shipping_address_city} name="city" placeholder="City.." type="text" />
                    {/* <input className="mobileFormElement2" onChange={e => { this.setState({ shipping_address_state: e.target.value }) }} placeholder="State.." type="text" /> */}
                    <select style={{ height: 41 }} className="mobileFormElement2" onChange={e => { this.setState({ shipping_address_state: e.target.value }) }} value={this.state.shipping_address_state}>
                        <option value="select">-Select-</option>
                        <option value="AL">Alabama</option>
                        <option value="AK">Alaska</option>
                        <option value="AZ">Arizona</option>
                        <option value="AR">Arkansas</option>
                        <option value="CA">California</option>
                        <option value="CO">Colorado</option>
                        <option value="CT">Connecticut</option>
                        <option value="DE">Delaware</option>
                        <option value="DC">District Of Columbia</option>
                        <option value="FL">Florida</option>
                        <option value="GA">Georgia</option>
                        <option value="HI">Hawaii</option>
                        <option value="ID">Idaho</option>
                        <option value="IL">Illinois</option>
                        <option value="IN">Indiana</option>
                        <option value="IA">Iowa</option>
                        <option value="KS">Kansas</option>
                        <option value="KY">Kentucky</option>
                        <option value="LA">Louisiana</option>
                        <option value="ME">Maine</option>
                        <option value="MD">Maryland</option>
                        <option value="MA">Massachusetts</option>
                        <option value="MI">Michigan</option>
                        <option value="MN">Minnesota</option>
                        <option value="MS">Mississippi</option>
                        <option value="MO">Missouri</option>
                        <option value="MT">Montana</option>
                        <option value="NE">Nebraska</option>
                        <option value="NV">Nevada</option>
                        <option value="NH">New Hampshire</option>
                        <option value="NJ">New Jersey</option>
                        <option value="NM">New Mexico</option>
                        <option value="NY">New York</option>
                        <option value="NC">North Carolina</option>
                        <option value="ND">North Dakota</option>
                        <option value="OH">Ohio</option>
                        <option value="OK">Oklahoma</option>
                        <option value="OR">Oregon</option>
                        <option value="PA">Pennsylvania</option>
                        <option value="RI">Rhode Island</option>
                        <option value="SC">South Carolina</option>
                        <option value="SD">South Dakota</option>
                        <option value="TN">Tennessee</option>
                        <option value="TX">Texas</option>
                        <option value="UT">Utah</option>
                        <option value="VT">Vermont</option>
                        <option value="VA">Virginia</option>
                        <option value="WA">Washington</option>
                        <option value="WV">West Virginia</option>
                        <option value="WI">Wisconsin</option>
                        <option value="WY">Wyoming</option>
                    </select>
                    <input className="mobileFormElement1" onChange={e => { this.setState({ shipping_address_zip: e.target.value }) }} value={this.state.shipping_address_zip} placeholder="Zip.." type="text" />
                </div>
                <input className="formInput" onChange={e => { this.setState({ shipping_address_phone: e.target.value }) }} value={this.state.shipping_address_phone} placeholder="Phone Number.." type="text" />

            </div >
        );
    }

    closeOverlay = () => {
        setTimeout(() => {
            this.setState({
                showOrderComplete: false
            });
        }, 400)
    }

    // renderOrderComplete = () => {
    //     if (this.state.showOrderComplete == true) {
    //         return <OrderComplete closeOverlay={this.closeOverlay} />;
    //     }
    // }

    renderProcessing = () => {
        if (this.state.showProcessing == true) {
            return (
                <div style={{ position: "absolute", height: 100 + "%", width: 100 + "%", top: "0px", zIndex: 9999, backgroundColor: "#413618" }}>
                    <div style={{ textAlign: "center", fontSize: "22px", color: "#fff", marginTop: "30px" }}>Processing Transaction <FaLock style={{ fontSize: "17px" }} /></div>
                    <div style={{ height: "40px", width: "40px", marginLeft: "auto", marginRight: "auto", marginTop: "30px" }}>
                        <img src={require('../images/rings.gif')} style={{ height: "40px", width: "40px" }} />
                    </div>
                </div>
            );
        }
    }

    renderAskQuestions = () => {
        if (this.state.subtotal > 0) {
            return (<div className="desktopTotal">
                <div style={{ padding: "10px", backgroundColor: "transparent", textAlign: "center" }} className="cart_itemRow">
                    <div style={{ flex: 1, color: "#fff" }}>Questions? Contact us at <a style={{ fontWeight: "bold", textDecoration: "none", color: "#0098c5" }} href="tel:2519786088" data-rel="external">251-978-6088</a> | <a style={{ fontWeight: "bold", textDecoration: "none", color: "#0098c5" }} target="_blank" href="https://www.houseplanstore.com/returns/">Return Policy</a></div>
                </div>
            </div>);
        }
    }

    renderTotal = () => {
        if (this.state.subtotal > 0) {
            return (<div className="total">
                <div style={{ padding: "10px" }} className="cart_itemRow">
                    <div style={{ flex: 5, fontWeight: "bold" }}>Total</div>
                    <div style={{ flex: 1, textAlign: "right", fontWeight: "bold" }}>${this.state.subtotal / 100}</div>
                </div>
            </div>);
        }
    }

    refreshSubtotal = () => {
        var body = new FormData();
        body.append('cartContents', localStorage.getItem('cart'));
        var url = "https://www.houseplanstore.com/web_api/?v=getSubtotal";
        var xhr = new XMLHttpRequest();
        xhr.open("POST", url, true);
        xhr.onload = function (e) {
            try {
                //console.log(xhr.responseText)
                //var json = JSON.parse(xhr.responseText);
                this.setState({
                    subtotal: (parseInt(xhr.responseText) * 100)
                });
                if (this.state.step !== 0) {
                    this.getCartItems();
                }
                console.log("subtotal", this.state.subtotal);

            } catch (err) {
                console.log(err);
            }
        }.bind(this);
        xhr.send(body);
    }

    renderNextStepButton = () => {
        if (localStorage.getItem('cart') !== null && this.state.subtotal > 0) {
            return (
                <div onClick={() => { this.setState({ step: 1 }); }} className="desktopSecureCheckoutButton">Secure Checkout <FaArrowCircleRight style={{ fontSize: "20px", position: "absolute", marginLeft: "9px", opacity: 0.8, top: "16px" }} /></div>
            );
        }
    }

    renderReviewOrderButton = () => {
        return (
            <div onClick={() => { this.validateShippingAddress() }} className="desktopSecureCheckoutButton">Review Order <FaArrowCircleRight style={{ fontSize: "20px", position: "absolute", marginLeft: "9px", opacity: 0.8, top: "16px" }} /></div>
        )
    }

    validateShippingAddress = () => {
        if (this.state.shipping_name == "") {
            alert("Please enter your name.");
            return;
        } else if (this.state.shipping_address_line1 == "") {
            alert("Please add a shipping address.");
            return;
        } else if (this.state.shipping_address_city == "") {
            alert("Please add a city.");
            return;
        } else if (this.state.shipping_address_state == "" || this.state.shipping_address_state == "select") {
            alert("Please select your state");
            return;
        } else if (this.state.shipping_address_zip == "") {
            alert("Please enter your zip code.");
            return;
        } else if (this.state.shipping_address_phone == "") {
            alert("Please enter your phone number.");
            return;
        }

        this.setState({ 
            cartItems:[],
            step: 2 
        });
        this.getCartItems(2);
    }

    renderCheckoutButton = () => {
        if (localStorage.getItem('cart') !== null && this.state.subtotal > 0) {
            return (
                <StripeCheckout
                    name="HousePlanStore.com" // the pop-in header title
                    description="Secure Payment" // the pop-in header subtitle
                    image="https://www.houseplanstore.com/images/sitelogo.png" // the pop-in header image (default none)
                    //ComponentClass="div"
                    label="Secure Payment" // text inside the Stripe button
                    panelLabel="Pay" // prepended to the amount in the bottom pay button
                    amount={this.state.subtotal} // cents
                    currency="USD"

                    //stripeKey="pk_test_FrXSENNgNWWPzNYUT20wIkIF"
                    stripeKey="pk_live_51J0SgwGAmfub0paPOcDthmlIM6VftmJGNwaFM2kBi4644DCfiRnZtl2rEWKcpeTMeDLpsY0V17UoNrRANrOiQKLi00Ioo4ywru"

                    locale="en"
                    //email="info@vidhub.co"
                    // Note: Enabling either address option will give the user the ability to
                    // fill out both. Addresses are sent as a second parameter in the token callback.
                    //shippingAddress
                    billingAddress={false}
                    // Note: enabling both zipCode checks and billing or shipping address will
                    // cause zipCheck to be pulled from billing address (set to shipping if none provided).
                    zipCode
                    //alipay // accept Alipay (default false)
                    //bitcoin // accept Bitcoins (default false)
                    allowRememberMe={false} // "Remember Me" option (default true)
                    token={this.onToken} // submit callback
                //opened={this.onOpened} // called when the checkout popin is opened (no IE6/7)
                //closed={this.onClosed} // called when the checkout popin is closed (no IE6/7)
                // Note: `reconfigureOnUpdate` should be set to true IFF, for some reason
                // you are using multiple stripe keys
                // reconfigureOnUpdate={false}
                // Note: you can change the event to `onTouchTap`, `onClick`, `onTouchStart`
                // useful if you're using React-Tap-Event-Plugin
                //triggerEvent="onTouchTap"
                >
                    <div onClick={() => { this.updateAnalytics() }} className="desktopSecureCheckoutButton">Payment <FaArrowCircleRight style={{ fontSize: "20px", position: "absolute", marginLeft: "9px", opacity: 0.8, top: "16px" }} /></div>
                </StripeCheckout>
            );
        }
    }

    updateAnalytics = () => {
        ReactGA.event({
            category: 'User',
            action: 'Clicked Checkout Button'
        });
        var total = this.state.subtotal / 100;
        total = total.toString();
        localStorage.setItem('total', total);
    }

    uuidv4 = () => {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    onToken = (token, addresses) => {
        //show processing screen with loading indicator
        this.setState({ showProcessing: true });
        window.scrollTo(0, 0);

        var body = new FormData();
        body.append("idempotency", this.state.idempotency);
        body.append("cartContents", localStorage.getItem('cart'));
        body.append("stripeEmail", token.email);
        body.append("stripeToken", token.id);
        body.append("stripeTokenType", token.type);
        body.append("stripeShippingName", this.state.shipping_name || "");
        body.append("stripeShippingAddressLine1", this.state.shipping_address_line1 || "");
        body.append("stripeShippingAddressZip", this.state.shipping_address_zip || "");
        body.append("stripeShippingAddressPhone", this.state.shipping_address_phone || "");
        body.append("stripeShippingAddressState", this.state.shipping_address_state || "");
        body.append("stripeShippingAddressCity", this.state.shipping_address_city || "");
        body.append("stripeShippingAddressCountry", addresses.shipping_address_country || "");
        body.append("stripeShippingAddressCountryCode", addresses.shipping_address_country_code || "");
        var url = "https://www.houseplanstore.com/web_api/?v=chargeStripev2";
        var xhr = new XMLHttpRequest();
        xhr.open("POST", url, true);
        xhr.onload = function (e) {
            try {
                console.log(localStorage.getItem('cart'), xhr.responseText);
                var json = JSON.parse(xhr.responseText);
                if (json[0] == "success") {
                    localStorage.setItem('orderId', json[1]);
                    window.scrollTo(0, 0);
                    document.body.classList.add('modal-open');
                    window.location.pathname = '/webapp/desktop_order_complete';
                    //this.setState({ showOrderComplete: true });
                } else if (json[0] == "declined") {
                    this.setState({ showProcessing: false });
                    alert("Card Declined");
                } else {
                    //an unknown error has occurred, your card has not been charged
                    this.setState({ showProcessing: false });
                    alert("An error in the checkout system occured. Your card has not been charged. Please call 251-978-6088 to complete your order.");
                }
                //this.setState({ showProcessing: false });

                //hide loading indicator and show transaction confirmation, email message, and link back home
                //remove localstorage cart object
            } catch (err) {
                this.setState({ showProcessing: false });
                alert("An error in the checkout system occured. Your card has not been charged. Please call 251-978-6088 to complete your order.");
                console.log(err);
            }
        }.bind(this);
        xhr.send(body);
    }


    getCartItems = (step) => {
        if (localStorage.getItem('cart') !== null) {
            //console.log(localStorage.getItem('cart'))
            var body = new FormData();
            body.append('cartContents', localStorage.getItem('cart'));
            var url = "https://www.houseplanstore.com/web_api/?v=getCartContents";
            var xhr = new XMLHttpRequest();
            xhr.open("POST", url, true);
            xhr.onload = function (e) {
                try {
                    console.log(xhr.responseText)
                    var json = JSON.parse(xhr.responseText);
                    var array = [];
                    for (var i = 0; i < Object.keys(json[0]).length; i++) {
                        //pass in the refreshSubtotal function so when an item is deleted, it's price gets removed from the total
                        array.push(<DesktopCartItem step={step} refreshSubtotal={this.refreshSubtotal} key={i} item={json[0][i]} />);
                    }
                    array.reverse();
                    this.setState({
                        cartItems: [...this.state.cartItems, ...array],
                        subtotal: (parseInt(json[1]) * 100)
                    });
                    console.log("subtotal", this.state.subtotal);

                } catch (err) {
                    console.log(err);
                }
            }.bind(this);
            xhr.send(body);
        }
    }


    componentDidMount() {
        this.getCartItems(0);
        this.setState({
            idempotency: this.uuidv4()
        });
        ReactGA.pageview('/webapp/desktop_shopping_cart/');
    }

}

export default DesktopCart;